import { render, staticRenderFns } from "./AntifraudButtons.vue?vue&type=template&id=14d96e6d&"
import script from "./AntifraudButtons.vue?vue&type=script&lang=js&"
export * from "./AntifraudButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports